import React from 'react'

const ExampleEmail = ({exampleEmail}) =>
{
  if (!exampleEmail) {
    return null
  }

  return (
    <div dangerouslySetInnerHTML={exampleEmail}/>
  )
}

export default ExampleEmail
